import { useEffect, useMemo } from "react";
import { useAppSelector } from "../../../../../Store";
import { Graph_QL } from "../../../../../Services";
import { useLanControllers } from "../../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useLanControllers";
import { useSystem } from "../../../../../Services/Agrisys_GqlDataCaller/SystemCalls/useSystem";
import { SelectFieldOption_Values } from "../../../../../Definitions";
import { useDeviceInfo } from "../../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useDeviceInfo";

export type OptionsWithRequiredNumberId = Pick<SelectFieldOption_Values, "label"> & {id: number};

export const useLcIoOptions = () => {
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);;

  const { data: lanControllerState, call: getLanControllers, getCpuOptions: getLanControllerCpuOptions} = useLanControllers(connection);
  const { getCpuOptions: getDeviceCpuOptions, data: deviceState } = useDeviceInfo(connection);
  const { data: systemState, call: getSystems} = useSystem(connection);

  const {lanControllerOptions, lanControllerCpuOptions } = useMemo(() => {
    if (lanControllerState[domain]) {
      return {
        lanControllerOptions: lanControllerState[domain].data.map(({controller_id, name}) => ({id: controller_id , label: name ?? controller_id.toString()})),
        lanControllerCpuOptions: lanControllerState[domain].cpuOptions?.map((cpuOption) => ({id: cpuOption.lanControllerId, label: cpuOption.cpuId})) ?? []
      }
    }
    return {lanControllerOptions: [] as OptionsWithRequiredNumberId[], lanControllerCpuOptions: [] as OptionsWithRequiredNumberId[]}
  },[domain, lanControllerState])

  const systemOptions: OptionsWithRequiredNumberId[] = useMemo(() => {
    return systemState[domain] ? systemState[domain].data.map(({systemId, name}) => ({id: systemId, label: name})) : []
  },[domain, systemState])

  const deviceCpuOptions: OptionsWithRequiredNumberId[] = useMemo(() => {
    if (deviceState[domain]) {
      return deviceState[domain].cpuOptions?.map((cpuOption) => ({id: cpuOption.deviceRegisterId, label: cpuOption.cpuId})) ?? [];
    }
    return []
  },[deviceState, domain])
  
  useEffect(() => {
    getDeviceCpuOptions()
    getLanControllerCpuOptions()
  },[])

  useEffect(() => {
    if (!systemState[domain]) {
      getSystems({fetchAmount: 50, offset: 0})
    }
  },[domain, getSystems, systemState])

  useEffect(() => {
    if (!lanControllerState[domain]) {
      getLanControllers({fetchAmount: 50, offset: 0})
    }
  },[domain, getLanControllers, lanControllerState])

  return {systemOptions, lanControllerOptions, lanControllerCpuOptions, deviceCpuOptions}
}